import { state, materialState, turkish } from "./../controls/state.js"
import { useSnapshot } from "valtio"
import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import { useGLTF } from "@react-three/drei"
import * as mats from "./mats.js"

function Audi(props) {
    const group = useRef()
    
    const {scene, nodes, materials} = useGLTF("models/audi.glb")
    const custom = mats.getMaterial()

    const snap = useSnapshot(state)
    const materialSnap = useSnapshot(materialState)
    
    const [hovered, set] = useState(null)
    useEffect(() => {
      const cursor = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><g filter="url(#filter0_d)"><path d="M29.5 47C39.165 47 47 39.165 47 29.5S39.165 12 29.5 12 12 19.835 12 29.5 19.835 47 29.5 47z" fill="${snap.items[hovered]}"/></g><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/><text fill="#000" style="white-space:pre" font-family="Inter var, sans-serif" font-size="10" letter-spacing="-.01em"><tspan x="35" y="63">${turkish[hovered]}</tspan></text></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath><filter id="filter0_d" x="6" y="8" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>`
      const auto = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/></svg>`
      document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(hovered ? cursor : auto)))}'), auto`
    }, [hovered])  
   
 
    return (
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
        onPointerOut={(e) => e.intersections.length === 0 && set(null)}
        onPointerMissed={() => (state.current = null)}
        onPointerDown={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}>
      <group rotation={[-Math.PI / 2, 0.06, 0.7]} position={0,0,-600}>
        <group position={[880.74, 0, 143.94]} rotation={[0, -0.1, 0]}>
          <group rotation={[Math.PI / 2, 0, 0]}>
            <group position={[0.03, 288.23, 2316.85]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Body_plastic_Body_plastic_0.geometry}
                material={nodes.Body_plastic_Body_plastic_0.material}
              />
              <mesh
                geometry={nodes.Body_plastic_Body_plastic_0001.geometry}
                material={nodes.Body_plastic_Body_plastic_0001.material}
              />
              <mesh
                geometry={nodes.Body_plastic_Body_plastic_0002.geometry}
                material={nodes.Body_plastic_Body_plastic_0002.material}
              />
              <mesh
                geometry={nodes.Body_plastic_Body_plastic_0003.geometry}
                material={nodes.Body_plastic_Body_plastic_0003.material}
              />
            </group>
            <group position={[883, 771.14, 788.69]} rotation={[-Math.PI / 2, 0, 0]}>
              <group position={[-882.98, -1528.16, -482.91]}>
                <mesh geometry={nodes.CarPaint_CarPaint_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
                <mesh geometry={nodes.CarPaint_CarPaint_0001.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
              </group>
            </group>
            <group position={[883, 771.14, 788.69]} rotation={[-Math.PI / 2, 0, 0]}>
              <group position={[-882.98, -1528.16, -482.91]}>
                <mesh geometry={nodes.Glass_GlassLights_0.geometry} material={nodes.Glass_GlassLights_0.material} />
                <mesh geometry={nodes.Glass_GlassRedLights_0.geometry} material={materials.GlassRedLights} />
                <mesh geometry={nodes.Glass_GlassTextured_0.geometry} material={custom["fsg" + materialSnap.items["front_side_glass"]]} material-color={snap.items.front_side_glass} />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0001.geometry}
                  material={nodes.Glass_GlassTextured_0001.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0002.geometry}
                  material={nodes.Glass_GlassTextured_0002.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0003.geometry}
                  material={nodes.Glass_GlassTextured_0003.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0004.geometry}
                  material={nodes.Glass_GlassTextured_0004.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0005.geometry}
                  material={nodes.Glass_GlassTextured_0005.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0006.geometry}
                  material={nodes.Glass_GlassTextured_0006.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0007.geometry}
                  material={nodes.Glass_GlassTextured_0007.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0008.geometry}
                  material={nodes.Glass_GlassTextured_0008.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0009.geometry}
                  material={nodes.Glass_GlassTextured_0009.material}
                />
                <mesh geometry={nodes.Glass_GlassTextured_0010.geometry} material={custom["fg" + materialSnap.items["front_glass"]]} material-color={snap.items.front_glass} />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0011.geometry}
                  material={nodes.Glass_GlassTextured_0011.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0012.geometry}
                  material={nodes.Glass_GlassTextured_0012.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0013.geometry}
                  material={nodes.Glass_GlassTextured_0013.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0014.geometry}
                  material={nodes.Glass_GlassTextured_0014.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0015.geometry}
                  material={nodes.Glass_GlassTextured_0015.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0016.geometry}
                  material={nodes.Glass_GlassTextured_0016.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0017.geometry}
                  material={nodes.Glass_GlassTextured_0017.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0018.geometry}
                  material={nodes.Glass_GlassTextured_0018.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0019.geometry}
                  material={nodes.Glass_GlassTextured_0019.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0020.geometry}
                  material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0021.geometry}
                  material={nodes.Glass_GlassTextured_0021.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0022.geometry}
                  material={nodes.Glass_GlassTextured_0022.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0023.geometry}
                  material={nodes.Glass_GlassTextured_0023.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0024.geometry}
                  material={nodes.Glass_GlassTextured_0024.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0025.geometry}
                  material={nodes.Glass_GlassTextured_0025.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0026.geometry}
                  material={nodes.Glass_GlassTextured_0026.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0027.geometry}
                  material={nodes.Glass_GlassTextured_0027.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0028.geometry}
                  material={nodes.Glass_GlassTextured_0028.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0029.geometry}
                  material={nodes.Glass_GlassTextured_0029.material}
                />
                <mesh geometry={nodes.Glass_GlassTextured_0030.geometry} material={custom["bg" + materialSnap.items["back_glass"]]} material-color={snap.items.back_glass} />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0031.geometry}
                  material={nodes.Glass_GlassTextured_0031.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0032.geometry}
                  material={nodes.Glass_GlassTextured_0032.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0033.geometry}
                  material={nodes.Glass_GlassTextured_0033.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0034.geometry}
                  material={nodes.Glass_GlassTextured_0034.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0035.geometry}
                  material={nodes.Glass_GlassTextured_0035.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0036.geometry}
                  material={nodes.Glass_GlassTextured_0036.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0037.geometry}
                  material={nodes.Glass_GlassTextured_0037.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0038.geometry}
                  material={nodes.Glass_GlassTextured_0038.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0039.geometry}
                  material={nodes.Glass_GlassTextured_0039.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0040.geometry}
                  material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0041.geometry}
                  material={nodes.Glass_GlassTextured_0041.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0042.geometry}
                  material={nodes.Glass_GlassTextured_0042.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0043.geometry}
                  material={nodes.Glass_GlassTextured_0043.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0044.geometry}
                  material={nodes.Glass_GlassTextured_0044.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0045.geometry}
                  material={nodes.Glass_GlassTextured_0045.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0046.geometry}
                  material={nodes.Glass_GlassTextured_0046.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0047.geometry}
                  material={nodes.Glass_GlassTextured_0047.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0048.geometry}
                  material={nodes.Glass_GlassTextured_0048.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0049.geometry}
                  material={nodes.Glass_GlassTextured_0049.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0050.geometry}
                  material={custom["fsg" + materialSnap.items["front_side_glass"]]} material-color={snap.items.front_side_glass}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0051.geometry}
                  material={nodes.Glass_GlassTextured_0051.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0052.geometry}
                  material={nodes.Glass_GlassTextured_0052.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0053.geometry}
                  material={nodes.Glass_GlassTextured_0053.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0054.geometry}
                  material={nodes.Glass_GlassTextured_0054.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0055.geometry}
                  material={nodes.Glass_GlassTextured_0055.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0056.geometry}
                  material={nodes.Glass_GlassTextured_0056.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0057.geometry}
                  material={nodes.Glass_GlassTextured_0057.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0058.geometry}
                  material={nodes.Glass_GlassTextured_0058.material}
                />
                <mesh
                  geometry={nodes.Glass_GlassTextured_0059.geometry}
                  material={nodes.Glass_GlassTextured_0059.material}
                />
                <mesh geometry={nodes.Glass_HdLightsLed_0.geometry} material={nodes.Glass_HdLightsLed_0.material} />
                <mesh geometry={nodes.Glass_HdLightsLens_0.geometry} material={materials.HdLightsLens} />
                <mesh geometry={nodes.Glass_RLightsChromeGlass_0.geometry} material={materials.RLightsChromeGlass} />
              </group>
            </group>
            <group position={[0, 771.94, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <group position={[0.01, -2316.85, -483.71]}>
                <mesh geometry={nodes.MetalDkGlossy_Chrome_0.geometry} material={materials['Chrome.001']} />
                <mesh
                  geometry={nodes.MetalDkGlossy_HdLightsPlasticBump_0.geometry}
                  material={materials.HdLightsPlasticBump}
                />
                <mesh geometry={nodes.MetalDkGlossy_intCarbon_0.geometry} material={materials.intCarbon} />
                <mesh
                  geometry={nodes.MetalDkGlossy_intMetallDk_0.geometry}
                  material={nodes.MetalDkGlossy_intMetallDk_0.material}
                />
                <mesh
                  geometry={nodes.MetalDkGlossy_intPlasticLtBump_0.geometry}
                  material={nodes.MetalDkGlossy_intPlasticLtBump_0.material}
                />
                <mesh geometry={nodes.MetalDkGlossy_LicPlate_0.geometry} material={materials.LicPlate} />
                <mesh geometry={nodes.MetalDkGlossy_MetalDkGlossy_0.geometry} material={materials.MetalDkGlossy} />
                <mesh geometry={nodes.MetalDkGlossy_MetalLt_0.geometry} material={materials.MetalLt} />
                <mesh geometry={nodes.MetalDkGlossy_Rubber_0.geometry} material={materials.Rubber} />
              </group>
            </group>
            <group position={[883, 771.14, 788.69]} rotation={[-Math.PI / 2, 0, 0]}>
              <group position={[-882.98, -1528.16, -482.91]}>
                <mesh geometry={nodes.others_Aluminum_0.geometry} material={materials.Aluminum} />
                <mesh geometry={nodes.others_ChromeLightsBump_0.geometry} material={materials.ChromeLightsBump} />
                <mesh geometry={nodes.others_GlassLights_0.geometry} material={nodes.others_GlassLights_0.material} />
                <mesh geometry={nodes.others_HdLightsLed_0.geometry} material={nodes.others_HdLightsLed_0.material} />
                <mesh geometry={nodes.others_intMetallDk_0.geometry} material={nodes.others_intMetallDk_0.material} />
                <mesh
                  geometry={nodes.others_intPlasticDkmatte_0.geometry}
                  material={nodes.others_intPlasticDkmatte_0.material}
                />
                <mesh
                  geometry={nodes.others_intPlasticDkmatte_0001.geometry}
                  material={nodes.others_intPlasticDkmatte_0001.material}
                />
              </group>
            </group>
            <group position={[0.03, 288.23, 2316.85]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.RLightsChromeGlass_intCarpet_0.geometry} material={materials.intCarpet} />
              <mesh geometry={nodes.RLightsChromeGlass_intFabricDk_0.geometry} material={materials.intFabricDk} />
              <mesh geometry={nodes.RLightsChromeGlass_intFabricLt_0.geometry} material={materials.intFabricLt} />
              <mesh geometry={nodes.RLightsChromeGlass_intPlasticGrey_0.geometry} material={materials.intPlasticGrey} />
              <mesh
                geometry={nodes.RLightsChromeGlass_intPlasticLtBump_0.geometry}
                material={nodes.RLightsChromeGlass_intPlasticLtBump_0.material}
              />
              <mesh geometry={nodes.RLightsChromeGlass_intPlasticRed_0.geometry} material={materials.intPlasticRed} />
              <mesh
                geometry={nodes.RLightsChromeGlass_intSeatPatterns_0.geometry}
                material={materials.intSeatPatterns}
              />
              <mesh geometry={nodes.RLightsChromeGlass_intTexButtons_0.geometry} material={materials.intTexButtons} />
              <mesh
                geometry={nodes.RLightsChromeGlass_intTexGlossyButtons_0.geometry}
                material={materials.intTexGlossyButtons}
              />
              <mesh geometry={nodes.RLightsChromeGlass_SeatLeather_0.geometry} material={materials.Leather} />
              <mesh geometry={nodes.RLightsChromeGlass_Speakers_0.geometry} material={materials.Speakers} />
            </group>
            <group position={[0.03, 288.23, 2316.85]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Undercarriage_Body_plastic_0.geometry} material={materials['Body_plastic.001']} />
              <mesh geometry={nodes.Undercarriage_intMetallDk_0.geometry} material={materials['intMetallDk.001']} />
            </group>
            <group position={[804.71, 336.01, 1432.97]} rotation={[-1.54, 0.06, -0.5]}>
              <group position={[-789.7, -883.87, -47.77]}>
                <mesh geometry={nodes.Wheels_BrakeCaliper_0.geometry} material={materials.BrakeCaliper} />
                <mesh geometry={nodes.Wheels_WheelAluminumRim_0.geometry} material={materials.WheelAluminumRim} />
                <mesh geometry={nodes.Wheels_WheelBrakeDisk_0.geometry} material={materials.WheelBrakeDisk} />
                <mesh geometry={nodes.Wheels_WheelGlossyMet_0.geometry} material={materials.WheelGlossyMet} />
                <mesh geometry={nodes.Wheels_WheelLogo_0.geometry} material={materials.WheelLogo} />
                <mesh geometry={nodes.Wheels_WheelMet_0.geometry} material={materials.WheelMet} />
                <mesh geometry={nodes.Wheels_WheelTireBMP_0.geometry} material={materials.WheelTireBMP} />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

export { Audi }